import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="layout">
      <main className="main-content">
        {children}
      </main>
      <footer className="footer">
        <div className="footer-content">
          <nav className="footer-nav">
            <Link 
              to="/" 
              className={`footer-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              OneTimer
            </Link>
            <Link 
              to="/faq" 
              className={`footer-link ${location.pathname === '/faq' ? 'active' : ''}`}
            >
              FAQ
            </Link>
            <Link 
              to="/terms.html" 
              className={`footer-link ${location.pathname === '/terms.html' ? 'active' : ''}`}
            >
              Terms & Privacy
            </Link>
            <Link 
              to="/developer" 
              className={`footer-link ${location.pathname === '/developer' ? 'active' : ''}`}
            >
              Contact
            </Link>
            <Link 
              to="/socials" 
              className={`footer-link ${location.pathname === '/socials' ? 'active' : ''}`}
            >
              Socials
            </Link>
          </nav>
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} OneTimer. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;